module.exports = __webpack_public_path__ + "static/img/theDefaultPage.ed63f50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/none/theDefaultPage.png
// module id = uWND
// module chunks = 60